import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatasetLinked = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M8.09 17H7V13H10.69C11.64 12.37 12.78 12 14 12H20C20.34 12 20.67 12.04 21 12.09V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H8.81C8.3 20.12 8 19.09 8 18C8 17.66 8.04 17.33 8.09 17ZM13 7H17V11H13V7ZM7 7H11V11H7V7Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 18C12 16.9 12.9 16 14 16H16V14H14C11.79 14 10 15.79 10 18C10 20.21 11.79 22 14 22H16V20H14C12.9 20 12 19.1 12 18ZM20 14H18V16H20C21.1 16 22 16.9 22 18C22 19.1 21.1 20 20 20H18V22H20C22.21 22 24 20.21 24 18C24 15.79 22.21 14 20 14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 17H20V19H14V17Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgDatasetLinked);
export default ForwardRef;
